
import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { WebSearchData } from '@/types/webSearch';
import WebSearchContent from './WebSearchContent';
import SourcesList from './SourcesList';
import ErrorBoundary from '../ErrorBoundary';

interface WebSearchDataViewProps {
  searchData: WebSearchData;
  leadName?: string;
}

const WebSearchDataView: React.FC<WebSearchDataViewProps> = ({ searchData, leadName }) => {
  
  return (
    <Tabs defaultValue="websearch">
      <TabsList className="w-full grid grid-cols-2">
        <TabsTrigger value="websearch">Web Search</TabsTrigger>
        <TabsTrigger value="sources">Sources</TabsTrigger>
      </TabsList>

      <TabsContent value="websearch" className="mt-4">
        <ErrorBoundary fallback={
          <div className="p-4 text-center text-muted-foreground">
            Unable to display details. Please try refreshing the data.
          </div>
        }>
          <WebSearchContent searchData={searchData} />
        </ErrorBoundary>
      </TabsContent>

      <TabsContent value="sources" className="mt-4">
        <SourcesList sources={searchData?.sources} />
      </TabsContent>
    </Tabs>
  );
};

export default WebSearchDataView;
